Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.MentionFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/mention/mention_filter"]

  events:
    'click #add-mention': '_apply'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet

  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template())
    return this

  _apply: (event) =>
    text = @$el.find("#mention").val()
    text = if text.indexOf('@') == 0 then text.substring(1) else text
    @searchQuery.addMention(text);
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
